<template>
  <div class="light">
    <div class="header">
      <div class="title">大屏设备列表</div>
      <div class="fast-btn">
        <my-button :state="state" @change="powerSwitch"></my-button>
      </div>
    </div>
    <div class="container">
      <round :device="d"
             v-for="(d,i) in remoteDevices"
             :key="`remote_d_${i}`">
        <div>
          <img :src="d.state && d.state.state ? require('@/assets/images/device/door-k.png') : require('@/assets/images/device/door.png')" style="height: 65px;"/>
        </div>
        <div slot="footer" class="footer">
          <div v-text="d.state && d.state.state ? '已开启' : '已关闭'"></div>
        </div>
      </round>
      <round class="empty"></round>
      <round class="empty"></round>
      <round class="empty"></round>
    </div>
  </div>
</template>
<script>
import Round from '@/components/Round'
import MyButton from '@/components/Button'
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import api from '@/model/device'

export default {
  name: 'DeviceScreen',
  computed: {
    ...mapState(['extDevices']),
    remoteDevices () {
      return this.extDevices.filter(d => d.devicetype.key === 'remote' && d.deviceKey === 91)
    },
    state () {
      return this.remoteDevices.length ? this.remoteDevices.every(l => l.state && l.state.state) : false
    }
  },
  components: {
    Round,
    MyButton
  },
  methods: {
    async powerSwitch () {
      try {
        if (this.remoteDevices.length) {
          await api.batchControl(['remote'], this.state ? 'close' : 'open')
        }
      } catch (e) {
        Message.error(e.message)
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/less/base";

.light {
  display: flex;
  flex-direction: column;
  flex: 1;
  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    > .title {
      font-size: 17px;
      font-weight: 600;
      color: rgba(38, 38, 38, 1);
    }
    > .fast-btn {
      display: flex;
      align-items: center;
    }
  }
  > .container {
    overflow-y: auto;
    margin-top: 5px;
    flex: 1;
    height: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      margin-top: 20px;
    }
  }
}
.round {
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
  }
}
</style>
